import styled from 'styled-components'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import Navigation from 'components/navigation'
import Footer from 'common/footer'
import OpenGraph from 'common/open-graph'
import NewProjectsGrid from 'projects/new-projects-grid'
import ProjectsPricing from 'projects/projects-pricing'
import projectsSections from 'projects/projects-sections'
import ProjectSection from 'projects/projects-section'
import WhatIsProjects from 'projects/what-is'
import ProjectsLandingHero from 'projects/landing/projects-landing-hero'
import { prefetchSubscriptionPlans } from 'querys/subscriptions'
import { prefetchProjects } from 'querys/projects'

import Link from 'next/link'
import { SecondaryButton } from 'common/button'

const ProjectsStyled = styled.main`
  color: var(--white);
  .faq {
    text-align: center;
    margin: 50px auto;
  }
  @media screen and (min-width: 1366px) {
    .faq {
      margin: -180px auto 180px;
    }
  }
`

function Projects() {
  return (
    <>
      <OpenGraph
        title="Bienvenido a proyectos."
        url="https://leonidasesteban.com/proyectos"
        keyword="Proyectos de Desarrolo Web, Portafolio de proyectos, Creación de Portafolio, Mas Proyectos Menos Diplomas"
        description="Usa tus habilidades para crear un excelente portafolio y conseguir el trabajo de tus sueños, nosotros nos encargamos del diseño."
        image="/images/open-graph/projects.png"
      />
      <Navigation background="var(--sky)" />
      <ProjectsStyled>
        <ProjectsLandingHero />
        <WhatIsProjects />
        {projectsSections.map((section) => (
          <ProjectSection key={section.icon} {...section} />
        ))}
        <div className="faq">
          <Link href="/blog/que-es-proyectos" passHref>
            <SecondaryButton>Saber más sobre proyectos</SecondaryButton>
          </Link>
        </div>
        <NewProjectsGrid />
      </ProjectsStyled>
      <ProjectsPricing />
      <Footer />
    </>
  )
}

Projects.pageTheme = {
  background: 'var(--projects-color)',
}

export async function getStaticProps() {
  const queryClient = new QueryClient()
  await prefetchProjects(queryClient)
  await prefetchSubscriptionPlans({ queryClient, product: 'PROJECTS' })
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 60 * 60 * 6,
  }
}

export default Projects
